import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loadable from 'react-loading-overlay';
import * as _ from 'lodash';

import { actionCreators } from '../actionCreators';

class RealtimeData extends React.Component {
  componentWillMount() {
    // observe user profile if is loggedIn
    const uid = _.get(this.props, 'currentUser.uid', null);
    if (uid) { this.props.dispatch(actionCreators.observeUserProfile(uid)); }
  }

  componentWillReceiveProps(nextProps) {
    const { currentUser } = this.props;
    const { currentUser: nextUser } = nextProps;
    const { uid: currentUid, client: currentClient, fleet: currentFleet } = currentUser || {};
    const { uid: nextUid, client: nextClient, fleet: nextFleet } = nextUser || {};

    // trigger network state onchange callback
    if (this.props.isOnline !== nextProps.isOnline) {
      this.networkStateWillChange(this.props.isOnline, nextProps.isOnline);
    }

    // trigger currentUser onchange callbacks
    if (currentUid !== nextUid) {
      this.currentUserWillChange(currentUser, nextUser);
    } else if (currentClient !== nextClient || currentFleet !== nextFleet) {
      this.currentUserParamsWillChange(currentUser, nextUser);
    }
  }

  componentWillUnmount() {
    // stop user profile observing if is loggedIn
    const { currentUser } = this.props;
    const { uid } = currentUser || {};
    if (uid) { this.props.dispatch(actionCreators.stopUserProfileObservation()); }
  }

  networkStateWillChange(/* currentState, nextState */) {}

  currentUserWillChange(currentUser, nextUser) {
    const { uid } = nextUser || {};

    if (uid) {
      this.props.dispatch(actionCreators.observeUserProfile(uid));
    } else {
      this.props.dispatch(actionCreators.stopUserProfileObservation());
    }
  }

  currentUserParamsWillChange(currentUser, nextUser) {
    const { client, fleet } = nextUser || {};
    this.props.dispatch(actionCreators.observeClientRealtimeData(client, fleet));
  }

  isLoading() {
    const { currentUser, isDataPublished } = this.props;
    const { uid, client, rule } = currentUser || {};
    return uid && (!client || !rule || !isDataPublished);
  }

  render() {
    return (
      <Loadable
        active={!this.props.isAuthFetched || this.isLoading()}
        spinner
        text={this.props.isAuthFetched ? 'Sincronizando dados...' : 'Aguarde...'}
        zIndex={1050}
      >
        {this.props.children}
      </Loadable>
    );
  }
}

RealtimeData.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    uid: PropTypes.string,
    client: PropTypes.string,
    rule: PropTypes.string,
  }),
  isOnline: PropTypes.bool,
  isAuthFetched: PropTypes.bool,
  isDataPublished: PropTypes.bool,
};

RealtimeData.defaultProps = {
  currentUser: null,
  isOnline: null,
  isAuthFetched: null,
  isDataPublished: null,
};

const mapStateToProps = state => ({
  currentUser: state.authState.currentUser,
  isOnline: state.appState.online,
  isAuthFetched: state.authState.isFetched,
  isDataPublished:
    state.vehicleState.firstPublish
    && state.driverState.firstPublish
    && state.fleetState.firstPublish,
});

export default connect(mapStateToProps, dispatch => ({ dispatch }))(RealtimeData);



// WEBPACK FOOTER //
// ./src/App/RealtimeData.js